import script from "./BaseInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseInfo.vue?vue&type=script&setup=true&lang=ts"

import "./BaseInfo.vue?vue&type=style&index=0&id=3cc955c4&scoped=true&lang=css"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cc955c4"]])

export default __exports__